<template>
  <!-- 电脑端-安全范围框（发布自动隐藏） -->
  <div id="u_c_QIH017" class="normal u_c_QIH017" v-show="compData.isShow" ></div>
  </template>
<script>
import {reactive,provide,inject,onMounted,watch,ref,computed} from "vue";
import Language from "@/hooks/language.js";
import Router from "@/hooks/router.js";
import bridge from "@/utils/sdkBridge.js";
import * as request from "@/api/request";
import * as utils from "@/utils";
import * as _ from "lodash";

export default {
  name: '',
  components: {},
  setup(){
    const { curLang, getLangTxt,langData } = Language();
    const routerData = inject("routerData",{});
    const pageData = inject("pageData", {});
    const COMP_DATA_LANG = {"default":{"isShow":true},"vi-VN":{"isShow":true}};
    const compData = reactive(COMP_DATA_LANG[curLang] || COMP_DATA_LANG['vi-VN']||{});

    const router = Router();

    // 自定义setup - 开始
    compData.isShow = false;;
    // 自定义setup - 结束
    return {pageData,routerData,compData,langData}
  }
}
</script>
<style lang="scss" scoped>
.default{.u_c_QIH017.normal{position:absolute;width:100.00vh;height:100.00vh;z-index:-1;border:4px solid lightgreen;box-sizing:border-box;top:0;left:50%;transform:translateX(-50%);}}.vi-VN{.u_c_QIH017.normal{position:absolute;width:100.00vh;height:100.00vh;z-index:-1;border:4px solid lightgreen;box-sizing:border-box;top:0;left:50%;transform:translateX(-50%);}}
</style>
